module.exports = __webpack_public_path__ + "img/benchi.398a3292.png";